






























import Vue, { PropType } from 'vue'
import DateTimeSelector from '@/components/DateTimeSelector.vue'
import Schedule from '@/types/Schedule.interface'
import { randomKey } from '@/utility/helpers'
export default Vue.extend({
    components: { DateTimeSelector },
    props: {
        //  Removes the 'delete' option from the line
        edit: {
            type: Boolean,
            default: false
        },
        //  The index of the schedule in the parents list
        index: {
            type: Number,
            required: true
        },
        //  Disables editing features
        readOnly: {
            type: Boolean,
            default: false
        },
        //  The schedule the component is bound to
        schedule: {
            type: Object as PropType<Schedule>,
            required: true
        }
    },
    data() {
        return {
            //  Unique key for schedule builder line
            lineKey: randomKey(),
            //  The loading spinner
            loading: false,
            //  The interval options availale to a schedule
            intervals: [
                'SEND ONCE',
                'DAILY',
                'WEEKLY',
                '1ST AND 15TH',
                'BIWEEKLY BY WEEKDAY',
                'MONTHLY',
                'BIANNUALLY',
                'ANNUALLY',
                'END OF MONTH'
            ]
        }
    },
    computed: {
        maxDate(): string {
            //  Get a new date
            const date = new Date()

            //  The maximum will be 1 year from now
            date.setFullYear(date.getFullYear() + 1)

            //  REturn it as an iso8601 string
            return date.toISOString()
        },
        minDate(): string {
            //  Min date is just today, can't schedule in the past
            return new Date().toISOString()
        }
    },
    methods: {
        onDateSelected(dateTimeString: string): void {
            //  If the datetime string does NOT exist, do nothing
            if (!dateTimeString) return

            //  Set the datetime string
            this.schedule.next_send = dateTimeString

            //  Emit change event
            this.$emit('change', this.schedule)
        }
    }
})
